export function getCurrencySymbol(currency: string): string {
  switch (currency) {
    case "USD":
      return "$";
    case "CAD":
      return "CAD";
    case "XAF":
      return "CFA";
    default:
      return "";
  }
}
